// src/components/projects/GiantTeacher.js
import React from "react";
import "../../styles/giantTeacher.css";
import VisualisationImg from "../../assets/visualisation.jpg";
import PersonalisationImg from "../../assets/personalisation.jpg";
import KnowledgeabilityImg from "../../assets/knowledgeability.jpg";


const giantTeacherData = {
  introduction: "The Giant Teacher Project aims to create AI-driven robotic models that provide personalised tutoring and mentorship using cutting-edge technology. The project specialises in visualisation, personalisation, and knowledgeability to enhance learning experiences.",
  specializationAreas: [
    { title: "Visualisation", description: "Using AI-generated interactive visuals and simulations to improve comprehension.", image: VisualisationImg },
    { title: "Personalisation", description: "Adapting teaching methods to suit individual learning styles for optimized understanding.", image: PersonalisationImg },
    { title: "Knowledgeability", description: "Ensuring deep subject expertise and responsive AI-driven tutoring.", image: KnowledgeabilityImg },
  ]
};

const GiantTeacher = () => {
  return (
    <div className="giant-teacher">
      <h1>Giant Teacher Project</h1>

      {/* Introduction Section */}
      <section className="intro">
        <p>{giantTeacherData.introduction}</p>
      </section>

      {/* Areas of Specialization */}
      <section className="specialization">
        <h2>Areas of Specialisation</h2>
        <div className="specialization-grid">
          {giantTeacherData.specializationAreas.map((area, index) => (
            <div key={index} className="specialization-card">
              <img src={area.image} alt={area.title} className="specialization-image" />
              <h3>{area.title}</h3>
              <p>{area.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default GiantTeacher;